module.exports = __webpack_public_path__ + "static/media/webinar_parawajah.0d5fbe1b.jpeg";